import { IdentifierDTO } from '@zazume/zzm-base';

import { PaginationOptions } from '#/hooks';
import { BasicUnit, BasicUser } from '#/models';
import { DraftDocument } from '#/models/drafts/DraftDocument';
import {
  CustomVariableValues,
  DraftDocumentCreateRequest,
  RequiredRelatedModels
} from '#/models/drafts/DraftDocumentCreateRequest';
import { DraftDocumentPreviewRequest } from '#/models/drafts/DraftDocumentPreviewRequest';
import { DraftDocumentUpdateRequest } from '#/models/drafts/DraftDocumentUpdateRequest';
import { TemplatePreviewResult } from '#/models/template/TemplatePreviewResult';
import { doDelete, doGet, doPost, doPut, EndpointBuilder, toPaginatedURL } from '#lib/network/helpers';

export const drafts = {
  documents: {
    calculatePreviewSettings:
      (id: IdentifierDTO, requiredRelatedModels: RequiredRelatedModels, customVariableValues?: CustomVariableValues) =>
      () =>
        doPut<TemplatePreviewResult>(`/dashboard/draft/documents/${id}/preview-variables`, {
          requiredRelatedModels,
          customVariableValues
        }),
    create: (request: DraftDocumentCreateRequest) => doPost('/dashboard/draft/documents', request),
    delete: (documentId: IdentifierDTO) => doDelete(`/dashboard/draft/documents/${documentId}`),
    duplicate: (documentId: IdentifierDTO) => doPost(`/dashboard/draft/documents/duplicate/${documentId}`),
    get: (id: IdentifierDTO) => () => doGet<DraftDocument>(`/dashboard/draft/documents/${id}`),
    getAuthors: () => doGet<BasicUser[]>('/dashboard/draft/documents/authors'),
    getImagePresignedPostURL: (templateId: IdentifierDTO) => (contentType: string, filename: string) =>
      doPost<{ url: string; fields: Record<string, string>; publicURL: string }>(
        `/dashboard/draft/documents/to-upload-url/${templateId}`,
        { contentType, filename }
      ),
    getPaginated: (params: EndpointBuilder) => (pagination: PaginationOptions) => () =>
      doGet<DraftDocument[]>(toPaginatedURL(`/dashboard/draft/documents${params.queryParams}`, pagination)),
    preview: (id: IdentifierDTO, request: DraftDocumentPreviewRequest) =>
      doPut<{ url: string }>(`/dashboard/draft/documents/${id}/preview`, request),
    update: (documentId: IdentifierDTO) => (request: DraftDocumentUpdateRequest) =>
      doPut(`/dashboard/draft/documents/${documentId}`, request),
    getDraftDocumentsUnits: () => () => doGet<BasicUnit[]>('/dashboard/draft/documents/units')
  }
};
